import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import { connect } from 'react-redux';
import { showModal, hideModal } from 'appSrc/redux/actions';
import { dAPI } from 'appSrc/api';
import { convertImage } from 'appSrc/utils';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import { Link } from 'react-router-dom';
import EditProductModal from '../../Modals/Product/EditProductModal';
import { CopyDrop } from '../../Common';
import style from './styles/style.module.css';

class InfiniteProductsTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            productInEdit: null,
            productInEditIndex: -1,
        };
    }
    updateProduct = ( index, desireid, data ) => {
        this.props.updateProduct( desireid, data )
        .then( ( product ) => {
            return this.props.onProductUpdated && this.props.onProductUpdated( index, product );
        } );
    }
    openEditModal = ( index, user ) => {
        this.setState( { productInEdit: user, productInEditIndex: index } );
        this.props.showModal( 'editProductModal' );
    }
    onEditSubmit = ( updates ) => {
        var index = this.state.productInEditIndex;
        var oldProduct = this.state.productInEdit;
        var calls = [];
        for( var i = 0; i < updates.tags.newTags.length; i++ ) {
            var tag = updates.tags.newTags[ i ];
            calls.push( this.props.addTagToProduct( oldProduct.desireid, tag.tagtext ) );
        }
        for( var j = 0; j < updates.tags.deletedTags.length; j++ ) {
            var dTag = updates.tags.deletedTags[ j ];
            calls.push( this.props.deleteTagFromProduct( oldProduct.desireid, dTag.tagtext ) );
        }
        return Promise.all( calls )
        .then( () => {
            return this.props.updateProduct( oldProduct.desireid, updates.product );
        } )
        .then( ( updatedProduct ) => {
            this.props.onProductUpdated( index, updatedProduct );
            return updatedProduct;
        } );
    }
    onEditClose = () => {
        this.props.hideModal( 'editProductModal' );
        this.setState( { productInEdit: null, productInEditIndex: -1 } );
    }


    render() {
        const { products } = this.props;

        return (
            <div>
                <InfiniteTable
                className={ style.productsTable }
                loadMore={ this.props.loadMore }
                elementHeight={ 90 }>
                    { this.arrayTableRows( products ) }
                </InfiniteTable>
                { this.state.productInEdit &&
                    <EditProductModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    product={ this.state.productInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( products ) => {
        var rows = products.map( ( product, index ) => {
            var individualSlug = `/admin/products/${ product.desireid }`;
            var publicSlug = `${ window.location.origin }/app/products/${ product.desireid }/${ encodeForURI(product.title) }`;
            return (
                <InfiniteTable.Row key={ product.desireid } className='dl-table-body'>
                    <InfiniteTable.Cell className={ style.coverImage }>
                        <Link to={ individualSlug }></Link>
                        <img src={ convertImage( product.image, '/100x100' ) } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { product.title }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }></Link>
                        { product.featured !== null ? ( <Icon source='fontAwesome' icon='fas/faCheck' style={ { color: 'inheirit' } } /> ) : null }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <CopyDrop content={ publicSlug } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, product );
                            } }/>
                            <DLMenu.Item text={ product.deactivated ? 'Activate' : 'Deactivate' }
                            onClick={ () => {
                                this.updateProduct( index, product.desireid, {
                                    deactivated: !product.deactivated,
                                    title: product.title,
                                } );
                            } }/>
                            <DLMenu.Item text={ product.featured ? 'Unfeature' : 'Feature' }
                            onClick={ () => {
                                this.updateProduct( index, product.desireid, {
                                    featured: !product.featured,
                                    title: product.title,
                                } );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell></InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    PRODUCT TITLE { sortIcon( 'title,desireid' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    FEATURED { sortIcon( 'featured,title,desireid' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell></InfiniteTable.Cell>
                <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}

InfiniteProductsTable.defaultProps = {
    onProductUpdated: ()=>{},
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        updateProduct: ( desireid, data ) => {
            return dAPI.patch( `/desires/${ desireid }`, dAPI.clean.product( data ) );

        },
        addTagToProduct: ( desireid, newTag ) => {
            return dAPI.post( `/desires/${ desireid }/tag`, { tag: newTag } );

        },
        deleteTagFromProduct: ( desireid, tagtext ) => {
            return dAPI.delete( `/desires/${ desireid }/tag/${ tagtext }` );

        },
    };
};

export default connect( null, mapDispatchToProps )( InfiniteProductsTable );
